<ng-content select="pw-header"></ng-content>
<ng-content select="pw-row"></ng-content>

<div class="table-payload-wrapper">
  <ng-content></ng-content>
</div>
